'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Limit = require('./Limit');

var _Limit2 = _interopRequireDefault(_Limit);

var _Page = require('./Page');

var _Page2 = _interopRequireDefault(_Page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Pagination, _React$Component);

  function Pagination() {
    (0, _classCallCheck3.default)(this, Pagination);
    return (0, _possibleConstructorReturn3.default)(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));
  }

  (0, _createClass3.default)(Pagination, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'paginated-pagination' },
        _react2.default.createElement(
          'div',
          { className: 'paginated-pagination-limit' },
          _react2.default.createElement(_Limit2.default, this.props)
        ),
        _react2.default.createElement(
          'div',
          { className: 'paginated-pagination-pages' },
          _react2.default.createElement(_Page2.default, this.props)
        )
      );
    }
  }]);
  return Pagination;
}(_react2.default.Component), _class.propTypes = {
  result: _react2.default.PropTypes.object,
  page: _react2.default.PropTypes.number,
  limit: _react2.default.PropTypes.number,
  setPage: _react2.default.PropTypes.func.isRequired,
  setLimit: _react2.default.PropTypes.func.isRequired
}, _temp);
exports.default = Pagination;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/Pagination/index.js
// module id = 2668
// module chunks = 0